<div
  [attr.id]="getConfig.elementId || null"
  [attr.data-ua-id]="trackingId"
>
  @if (value) {
    <div [innerHTML]="getSanitisedContent()"></div>
  }

  @if (!value) {
    <ng-content select="[defaultContent]" />
  }
</div>
